import { useState, useEffect, useCallback } from 'react';
import './FiltroData.css';

const hojeStr = () => new Date().toISOString().split('T')[0];

const mesAtualStr = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}`;
};

const anoAtualNum = () => new Date().getFullYear();

function calcPeriodo(modo, dia, mes, ano, periDi, periDf) {
  if (modo === 'dia') {
    if (!dia) return null;
    return { di: dia, df: dia };
  }
  if (modo === 'mes') {
    if (!mes) return null;
    const [y, m] = mes.split('-').map(Number);
    const ultimo = new Date(y, m, 0).getDate();
    return { di: `${mes}-01`, df: `${mes}-${String(ultimo).padStart(2, '0')}` };
  }
  if (modo === 'ano') {
    return { di: `${ano}-01-01`, df: `${ano}-12-31` };
  }
  if (modo === 'periodo') {
    if (!periDi || !periDf) return null;
    return { di: periDi, df: periDf };
  }
  return null;
}

function formatLabel(modo, dia, mes, ano, periDi, periDf) {
  const fmt = (s) => new Date(s + 'T12:00:00').toLocaleDateString('pt-BR');
  if (modo === 'dia' && dia) return fmt(dia);
  if (modo === 'mes' && mes) return new Date(mes + '-15').toLocaleDateString('pt-BR', { month: 'long', year: 'numeric' });
  if (modo === 'ano') return String(ano);
  if (modo === 'periodo' && periDi && periDf) return `${fmt(periDi)} até ${fmt(periDf)}`;
  return '';
}

export default function FiltroData({ onChange, defaultModo = 'mes' }) {
  const [modo,   setModo]   = useState(defaultModo);
  const [dia,    setDia]    = useState(hojeStr());
  const [mes,    setMes]    = useState(mesAtualStr());
  const [ano,    setAno]    = useState(String(anoAtualNum()));
  const [periDi, setPeriDi] = useState('');
  const [periDf, setPeriDf] = useState('');

  const emitir = useCallback((m, d, ms, a, pdi, pdf) => {
    const periodo = calcPeriodo(m, d, ms, a, pdi, pdf);
    if (!periodo) return;
    onChange({ ...periodo, label: formatLabel(m, d, ms, a, pdi, pdf) });
  }, [onChange]);

  // Emite ao montar com período padrão
  useEffect(() => {
    emitir(modo, dia, mes, ano, periDi, periDf);
  }, []); // eslint-disable-line

  const trocarModo = (m) => {
    setModo(m);
    emitir(m, dia, mes, ano, periDi, periDf);
  };

  return (
    <div className="fd-root">
      <div className="fd-modos">
        <button className={`fd-btn${modo === 'dia'     ? ' fd-btn--ativo' : ''}`} onClick={() => trocarModo('dia')}>Dia</button>
        <button className={`fd-btn${modo === 'mes'     ? ' fd-btn--ativo' : ''}`} onClick={() => trocarModo('mes')}>Mês</button>
        <button className={`fd-btn${modo === 'ano'     ? ' fd-btn--ativo' : ''}`} onClick={() => trocarModo('ano')}>Ano</button>
        <button className={`fd-btn${modo === 'periodo' ? ' fd-btn--ativo' : ''}`} onClick={() => trocarModo('periodo')}>Período</button>
      </div>

      <div className="fd-inputs">
        {modo === 'dia' && (
          <input
            type="date" className="fd-input" value={dia} max={hojeStr()}
            onChange={e => { if (e.target.value) { setDia(e.target.value); emitir('dia', e.target.value, mes, ano, periDi, periDf); } }}
          />
        )}
        {modo === 'mes' && (
          <input
            type="month" className="fd-input" value={mes} max={mesAtualStr()}
            onChange={e => { if (e.target.value) { setMes(e.target.value); emitir('mes', dia, e.target.value, ano, periDi, periDf); } }}
          />
        )}
        {modo === 'ano' && (
          <select
            className="fd-input" value={ano}
            onChange={e => { setAno(e.target.value); emitir('ano', dia, mes, e.target.value, periDi, periDf); }}
          >
            {Array.from({ length: 6 }, (_, i) => anoAtualNum() - i).map(y => (
              <option key={y} value={y}>{y}</option>
            ))}
          </select>
        )}
        {modo === 'periodo' && (
          <>
            <input
              type="date" className="fd-input" value={periDi} max={hojeStr()}
              onChange={e => { setPeriDi(e.target.value); emitir('periodo', dia, mes, ano, e.target.value, periDf); }}
            />
            <span className="fd-ate">até</span>
            <input
              type="date" className="fd-input" value={periDf} max={hojeStr()}
              onChange={e => { setPeriDf(e.target.value); emitir('periodo', dia, mes, ano, periDi, e.target.value); }}
            />
          </>
        )}
      </div>
    </div>
  );
}
